import { useDialog } from "../DialogProvider/DialogProvider";

function ThankyouContactUs({ show }) {
    const { openDialog, closeDialog, animation } = useDialog();
    return (
        show && <div className='popup-wrapper' onClick={closeDialog}>
            <div className='popup-body animation' style={{ animationName: animation }} onClick={(e) => e.stopPropagation()}>
                <div className="d-flex flex-column gap-48">
                    <div className="d-flex flex-column gap-24">
                        <div className='bold-heading'>Thank you</div>
                        <p className="theme-text-small-16">Thank you for contact Us! Our team will get back to you as soon as possible.</p>
                        <div><button className="menu-outline-btn-theme" onClick={closeDialog}>Done</button></div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ThankyouContactUs
